<template>
    <div class="form-group">
        <label v-if="title && title.trim().length > 0">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <VueDatePicker 
        v-model="model" 
        auto-apply 
        :enable-time-picker="false" 
        :disabled="isReadOnly? true: false" 
        :placeholder="placeholder || ''" 
        format="yyyy" year-picker
        :state="error ? false : true" 
        :close-on-auto-apply="true" 
        :year-range="[minYear, maxYear]" 
        @update:model-value="$emit('onChange', $event)" />
        <div class="text-danger text-right" style="margin-top: -13 !important;" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { ref, toRefs } from "vue";
export default {
    components: {
        
    },
    name: "TheYearPicker",
    props: {
        title: String,
        placeholder: String,
        initialValue: {
            type: [String, Number],
            default: null,
        },
        error: String,
        minYear: String,
        maxYear: String,
        isReadOnly: Boolean,
        isRequire: Boolean
    },
    data() {
        return {
            minVal: '',
            maxVal: ''
        }
    },
    setup(props) {
        const model = ref()
        let { initialValue } = toRefs(props)
        model.value = initialValue.value
        return { model }
    },
    methods: {
        handleDate (modelData) {
            this.model.value = modelData
        }
    },
    mounted() {
        this.minVal = this.minDate ? '1950' : this.minYear
        this.maxVal = this.maxDate ? new Date().getFullYear() : this.maxYear 
    }
}
</script>